import React, { FC, useCallback } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';
import { IBrand } from 'feature/supplierTabs/priceList/usePriceList';

interface IBrandsDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: IBrand[];
}

export const BrandsDrawer: FC<IBrandsDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  const navigate = useNavigate();
  const onRedirectToBrand = useCallback(
    (value: string) => {
      navigate(`${ADMIN_ROUTES.brand.view}/${value}/management`);
    },
    [navigate]
  );
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Brands'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row gutter={[0, 12]}>
        {data?.map((brand) => (
          <Col key={brand.id} span={24}>
            <Row align={'middle'} className={'gap-10'} wrap={false}>
              <Typography.Text
                underline
                type={'secondary'}
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => onRedirectToBrand(brand.id)}
              >
                {brand.name}
              </Typography.Text>
            </Row>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
